import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { PhaserSlider } from "src/games/shared/TriSlider";

export class Pet extends Phaser.GameObjects.Sprite {
    id: number;
    homeId: number;
    name: string;
    isHome: boolean;
    startingPosition: Phaser.Geom.Point;


    constructor(scene: Phaser.Scene, ob: TiledGameObject, id: number) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name + "1");
        this.id = id;
        this.homeId = ob.properties["id"] as number;
        this.name = ob.name;
        this.isHome = false;
        this.type = "Pet";
        this.startingPosition = new Phaser.Geom.Point(this.x, this.y);

        this.setDepth(5);

        var topLeft = this.getTopLeft();

        var rect = new Phaser.Geom.Rectangle(topLeft.x - ob.properties["x"],
            topLeft.y - ob.properties["y"],
            ob.properties["width"],
            ob.properties["height"]);

        this.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
        this.scene.input.setDraggable(this);

        this.playAnimation(ob);

        this.scene.add.existing(this);
    }

    playAnimation(ob) {
        this.scene.anims.create({
            key: ob.name,
            frames: this.scene.anims.generateFrameNames("assets", {
                prefix: ob.name,
                start: 1,
                end: 4
            }),
            frameRate: 6,
            repeat: -1,
            delay: 500 * this.id,
            repeatDelay: 300
        });

        this.anims.play(ob.name);
    }

}

export class PetItem extends Phaser.GameObjects.Sprite {
    id: number;
    homeId: number;
    name: string;
    isHome: boolean;
    startingPosition: Phaser.Geom.Point;

    constructor(scene: Phaser.Scene, ob: TiledGameObject, id: number) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name);
        this.id = id;
        this.homeId = ob.properties['id'] as number;
        this.name = ob.name;
        this.isHome = false;
        this.type = "PetItem";
        this.startingPosition = new Phaser.Geom.Point(this.x, this.y);

        this.setInteractive();
        this.scene.input.setDraggable(this);

        this.scene.add.existing(this);
    }
}

export class PetHome extends Phaser.GameObjects.Sprite {
    id: number;
    name: string;
    isOccupied: boolean;
    items: Set<PetItem>;

    topLayer?: Phaser.GameObjects.Sprite;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name);
        this.id = ob.properties["id"] as number;
        this.name = ob.name;
        this.isOccupied = false;
        this.items = new Set<PetItem>();
        this.type = "PetHome";

        if (this.name !== "tree") {
            this.setDepth(1);
        }

        // Set as a dropzone
        this.setInteractive();
        this.input.dropZone = true;

        // Add top layer over whatever is in the tank/cage (cage bars, tank glass)
        if (this.name === "tank" || this.name === "cage") {
            this.topLayer = this.scene.add.sprite(this.x, this.y, "assets", this.name + "Front");
            this.topLayer.setDepth(4);
        }

        this.scene.add.existing(this);
    }

    updateHome(item: Pet | PetItem) {
        var name = this.name + "-" + item.name;
        var frame = name;
        if (item.type === "Pet") {
            frame += "1";
        }
        var homeWithItem = this.scene.add.sprite(this.x, this.y, "assets", frame);

        if (item.name === "brush" || item.name === "cheesy_acorns") {
            homeWithItem.setDepth(3.5);
        }
        else if (item.name === "honey_bugs") {
            homeWithItem.setDepth(4.1);
        }
        else {
            homeWithItem.setDepth(3.1);
        }

        // Animation for pet inside it's home
        if (item.type === "Pet") {
            this.animatePetInHouse(name, homeWithItem);
        }
    }

    animatePetInHouse(name: string, homeWithItem: Phaser.GameObjects.Sprite) {
        this.scene.anims.create({
            key: name,
            frames: this.scene.anims.generateFrameNames("assets", {
                prefix: name,
                start: 1,
                end: 2,
            }),
            frameRate: 4,
            repeat: -1
        });

        homeWithItem.anims.play(name);
    }
}



// WEBPACK FOOTER //
// ./src/games/SpacePets/objects/Pet.ts